import * as Yup from "yup";
import { reverseShape } from "Components/shared/helpers/reverse-shape";
import { validString } from "Components/shared/helpers/validations";

const issueTypeObject = Yup.object().shape(reverseShape({
  id: validString.optional(),
  remarks: validString.optional(),
  name: validString.optional(),
}))

// const issueType = Yup.array().min(1).of(issueTypeObject)


export const ParcelsOrderRejectFlagSchema = Yup.object().shape(
  reverseShape({
    issueType: issueTypeObject.required(),
    remarks: validString.optional(),
  })
);

export const ParcelsOrderCancelSchema = Yup.object().shape(
  reverseShape({
    remarks:validString.optional(),
  })
)